<ms-split-header #splitHeaderComponent [enableScroll]="isInSheetView">
    <ng-container slot="header">
        @if (showMarketHelp) {
            <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
        }
        @if (isTeamGroupingEnabled) {
            <ms-team-grouping-tab-bar
                [event]="event"
                [optionGroup]="optionGroup"
                (teamGroupingChange)="onTeamGroupingChange($event)"></ms-team-grouping-tab-bar>
        }
    </ng-container>
    <ng-container slot="content">
        <div class="option-group-container player-props-container triple" [style.--option-group-rows]="visibleOptionGroups()">
            <div class="option-group-header">
                <span></span> <span>{{ overHeader }}</span> <span>{{ underHeader }}</span>
            </div>
            <div class="option-group-row" *rxFor="let optionLine of optionLines$; trackBy: trackOptionLine">
                <div class="attribute-key">
                    @if (isShowHeadshotImage) {
                        <ms-participant-image
                            class="participant-logo"
                            [participantImage]="optionLine.underOption?.image ?? optionLine.overOption?.image"
                            [showLogoColor]="true"
                            [participantType]="participantType.Player"
                            [sportId]="event?.sport.id" />
                    }
                    <div class="player-props-player-name">
                        {{ optionLine.playerName }}
                        @if (showPlayerStats) {
                            <ms-player-stats
                                [playerStats]="event.playerStats"
                                [sportId]="event.sport.id"
                                [playerStatsProps]="optionGroup.detailedGrouping.playerStatsProps"
                                [playerIds]="[optionLine.playerId]"
                                [source]="optionGroup.source" />
                        }
                    </div>
                </div>
                @if (optionLine.overOption) {
                    <ms-option
                        [tracking]="{
                            source: tracking,
                            moduleType: trackingModuleType,
                            controllerTabName: controllerTabName,
                            playersName: optionLine.playerName,
                        }"
                        [option]="optionLine.overOption"
                        [optionGroup]="optionGroup"
                        [event]="event"
                        [showPromoBadge]="!!crmPromoIdsMap[optionLine.overOption.id]"
                        [sourceOfPick]="sourceOfPick"
                        [betDetails]="betDetails"></ms-option>
                } @else {
                    <ng-container *ngTemplateOutlet="emptyOption"></ng-container>
                }
                @if (optionLine.underOption) {
                    <ms-option
                        [tracking]="{
                            source: tracking,
                            moduleType: trackingModuleType,
                            controllerTabName: controllerTabName,
                            playersName: optionLine.playerName,
                        }"
                        [option]="optionLine.underOption"
                        [optionGroup]="optionGroup"
                        [event]="event"
                        [showPromoBadge]="!!crmPromoIdsMap[optionLine.underOption.id]"
                        [sourceOfPick]="sourceOfPick"
                        [betDetails]="betDetails"></ms-option>
                } @else {
                    <ng-container *ngTemplateOutlet="emptyOption"></ng-container>
                }
            </div>
        </div>
    </ng-container>
</ms-split-header>
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}

<ng-template #emptyOption>
    <ms-option-pick-placeholder class="option" />
</ng-template>
